import AdminLayout from '../../components/feature/AdminLayout';
import TicketsTable from './components/TicketsTable';

export default function SupportPage() {
  return (
    <AdminLayout>
      <TicketsTable />
    </AdminLayout>
  );
}
